import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { PermissionsService } from 'app/shared/services/permissions.service';

export const RoleGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const permissionsService = inject(PermissionsService);
    const authService = inject(AuthService);

    return of(permissionsService.checkPermissions({ minimumRole: route.data['minimumRole'], allowedRoles: route.data['allowedRoles'] })).pipe(
        map(hasPermission => {
            if (hasPermission) {
                return true;
            }

            authService.signOut();
            return false;
        })
    );
};
